import { BankAccountsContext } from '@app/collections/fortress/BankAccountsContext'
import {
  Collapse,
  CollapsePanel,
  Divider,
  If,
  Notification,
  Row,
  Select,
  Spacer,
  Text,
  useWatch,
} from '@app/components'
import { ADD_NEW_INTL_WIRE_FORM, ADD_NEW_WIRE_FORM, wireStates } from '@app/data'
import { DynamicForm, generateDynamicFields } from '@app/modules'
import { IStore } from '@app/redux'
import { auth, errorHandler } from '@app/services'
import { EComponentMode } from '@app/types'
import { Col } from 'antd'
import axios from 'axios'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import { BankIcon } from '~public'

import { CustomSelect } from '../ach-pull/custom-select'

export const WireTransferContent: React.FC<any> = ({
  wireTransactionType,
  setWireTransactionType,
  mode,
  form,
  selectedMethod,
  setSelectedMethod,
}) => {
  const componentRef = useRef()
  const [activeKey, setActiveKey] = useState(null) // collapse active key
  const watcher = { country: useWatch('country', form), countryb: useWatch('countryb', form) }
  const { wireAccounts, fetchAccounts } = useContext(BankAccountsContext)

  useEffect(() => {
    fetchAccounts()
  }, [])

  const handleCollapseChange = (key) => {
    setActiveKey(key)
  }

  const { user } = useSelector((state: IStore) => state)

  const onWireSubmit = async (key) => {
    try {
      const data = await form.validateFields()
      //data.outgoing = true
      data.identityId = user.selectedEntityName ? user.selectedEntityIdentityId : null
      data.wireType = wireTransactionType

      const authorization = await auth.currentUser.getIdToken()
      const headers = {
        Authorization: authorization,
      }
      await axios.post('/api/north-one/manual-wire', data, { headers })
    } catch (error) {
      Notification({ message: error.message, type: 'error' })
      errorHandler.report`Failed to add wire account: ${error}`
    } finally {
      handleCollapseChange(key)
      await fetchAccounts()
      setSelectedMethod(wireAccounts[0])
    }
  }

  /**
   * It takes the `accounts` array, maps over it, and returns an array of objects with the following
   * properties: `id`, `title`, `icon`, and `description`
   * @returns An array of objects.
   */
  const generateMethodList = () => {
    return (
      wireAccounts?.map((item) => {
        return {
          id: item.id,
          name: (
            <>
              <BankIcon /> <Text>{`${item['accountNumber']}`}</Text>
            </>
          ),
          //icon: <BankIcon />,
          description: 'Out-going Wire Account',
          val: item?.id,
        }
      }) || []
    )
  }

  return (
    <Row gutter={[30, 30]}>
      <Col span={24} ref={componentRef}>
        <CustomSelect
          type="Wire Account"
          selected={selectedMethod}
          setSelected={setSelectedMethod}
          list={generateMethodList()}
        />

        <Divider />

        <Collapse activeKey={activeKey} onChange={handleCollapseChange}>
          <CollapsePanel header="Add Wire Account" key="1">
            <If condition={mode !== EComponentMode.VIEW}>
              <Row gutter={[10, 10]}>
                <Col span={24}>
                  <Text>Select transfer type</Text>
                </Col>
                <Col span={24}>
                  <Select
                    width="100%"
                    placeholder="Select transfer type"
                    value={wireTransactionType}
                    options={[
                      { value: 'wire-instructions', label: 'Domestic' },
                      { value: 'wire-instructions-intl', label: 'International' },
                    ]}
                    onChange={(v) => setWireTransactionType(v)}
                  />
                  <Spacer />
                </Col>
              </Row>
            </If>
            <Row gutter={[10, 10]}>
              <Col span={24}>
                <DynamicForm
                  fields={
                    wireTransactionType == 'wire-instructions-intl'
                      ? generateDynamicFields(ADD_NEW_INTL_WIRE_FORM, [
                        { name: 'region', options: wireStates[watcher.country] },
                        { name: 'regionb', options: wireStates[watcher.countryb] },
                      ])
                      : generateDynamicFields(ADD_NEW_WIRE_FORM, [
                        { name: 'region', options: wireStates[watcher.country] },
                        { name: 'regionb', options: wireStates[watcher.countryb] },
                      ])
                  }
                  form={form}
                  onSubmit={onWireSubmit}
                />
              </Col>
            </Row>
          </CollapsePanel>
        </Collapse>
      </Col>
    </Row>
  )
}
